module.exports = __webpack_public_path__ + "img/1.001ab4ac.jpg";